<template>
  <div>
    <div class="base-table-container">
      <div class="table-scroll-wrapper">
        <TableWrapper :headers="headers">
          <template v-if="isLoading && mode === 'orders'">
            <TableSkeletonLoader
              v-for="index in 3"
              :key="index"
              :index="index - 1"
              :rowLength="5"
              mode="orders"
              actionColumnWidth="270"
            />
          </template>
          <template v-else>
            <div v-if="mode === 'orders'">
              <OrderTableLine
                v-for="(row, index) in rows"
                :key="row.ord"
                :order="row"
                :rowLength="rows.length"
                :index="index"
              />
            </div>
          </template>
          <template v-if="isLoading && mode === 'invoices'">
            <TableSkeletonLoader
              v-for="index in 3"
              :key="index"
              :index="index - 1"
              :rowLength="5"
              actionColumnWidth="300"
            />
          </template>
          <template v-else>
            <div v-if="mode === 'invoices'">
              <InvoiceTableLine
                v-for="row in rows"
                :key="row.ord"
                :invoice="row"
              />
            </div>
          </template>
        </TableWrapper>
      </div>
    </div>
    <v-pagination
      class="mt-2 mb-5"
      v-model="currentPage"
      :active-color="'#BD9478'"
      :length="numberOfPages"
      :total-visible="7"
      rounded="circle"
      @update:modelValue="handlePageChange"
    ></v-pagination>
  </div>
</template>

<script>
import InvoiceTableLine from "../../helpers/AccountPage/Tables/InvoiceTableLine.vue";
import OrderTableLine from "../../helpers/AccountPage/Tables/OrderTableLine.vue";
import TableSkeletonLoader from "./TableSkeletonLoader.vue";
import TableWrapper from "./TableWrapper.vue";

export default {
  components: {
    TableWrapper,
    OrderTableLine,
    InvoiceTableLine,
    TableSkeletonLoader,
  },
  emits: ["update-page"],
  props: {
    mode: {
      type: String,
    },
    headers: {
      type: Array,
    },
    rows: {
      type: Array,
    },
    isLoading: {
      type: Boolean,
    },
    numberOfPages: {
      type: Number,
    },
    page: {
      type: Number,
      required: true,
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(value) {
        this.handlePageChange(value);
      }
    }
  },
  methods: {
    handlePageChange(newPage) {
      // Emit the page change event to the parent
      this.$emit('update-page', newPage);
    },
  },
};
</script>

<style lang="scss" scoped>
.base-table-container {
  width: 100%;
  position: relative;
  padding: 1px;
  padding-bottom: 0px;
  border-radius: 10px;
  border: 1px solid $tableOrderColor;
}

.table-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media only screen and (max-width: 768px) {
  // .v-pagination {
  //   :deep(.v-pagination__list) {
  //     flex-wrap: wrap;
  //     justify-content: center;
  //   }
  // }
}
</style>